import { useSyncExternalStore } from 'react';

const listeners = new Set();
let now = new Date().toISOString();
let timer;
function refresh() {
  const next = new Date().toISOString();
  if (next === now) return;
  now = next;
  listeners.forEach(listener => listener());
}
function subscribe(listener) {
  listeners.add(listener);
  // Synchronize lists with the wall clock, including midnight while visible
  // and elapsed time after a suspended tab. One timer serves every subscriber.
  if (listeners.size === 1) {
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    timer = window.setInterval(refresh, 60000);
  }
  return () => {
    listeners.delete(listener);
    if (!listeners.size) {
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
      window.clearInterval(timer);
    }
  };
}
function snapshot() {
  const current = Date.now();
  if (Math.floor(current / 60000) !== Math.floor(Date.parse(now) / 60000)) now = new Date(current).toISOString();
  return now;
}
export default function useDateTimeNow() {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
